/*
 *  Interface représentant une facture fournisseur telle qu'utilisé dans l'application React et l'application API
 */

import {
	faFileAlt,
	faLock,
	faPaperPlane,
	faCheck,
	faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import type { StatusConfig } from '../../../common/components/StatusCard/StatusCard';
import { TiersData } from 'features/tiers';
import { UserData } from 'features/users';
import { ExpenseData } from 'features/expenses';

export interface SupplierInvoiceData {
	workflowLock?: { locked: boolean; message: string; remedy: string } | null;
	id: number;
	label: string;

	supplierInvoiceReference?: string | null;
	supplierInvoiceDate?: Date | null;
	supplier?: TiersData | null;
	internalContact?: UserData | null;
	amount?: number | null;
	createdAt?: Date;
	status?: string;
	penaltyAndCarePercent?: number | null;
	expenses?: ExpenseData[];
	referenceNumber?: string | null;
}

export const SUPPLIER_INVOICE_STATUS_CONFIG: StatusConfig = {
	steps: [
		{
			key: 'CANCELED',
			icon: faTimesCircle,
			color: 'bg-red-600 text-white',
			textColor: 'text-red-600',
			label: 'Annulée',
			side: true,
		},
		{
			key: 'DRAFT',
			icon: faFileAlt,
			color: 'bg-blue-600 text-white',
			textColor: 'text-blue-600',
			label: 'Brouillon',
		},
		{
			key: 'READY',
			icon: faCheck,
			color: 'bg-purple-500 text-white',
			textColor: 'text-purple-600',
			label: 'Prête',
		},
		{
			key: 'ON_HOLD',
			icon: faLock,
			color: 'bg-amber-500 text-white',
			textColor: 'text-amber-600',
			label: 'Bloquée',
		},
		{
			key: 'SENT',
			icon: faPaperPlane,
			color: 'bg-green-600 text-white',
			textColor: 'text-green-600',
			label: 'Envoyée',
		},
	],
	transitions: {
		CANCELED: [{ to: 'DRAFT', label: 'Brouillon', type: 'main' }],
		DRAFT: [{ to: 'READY', label: 'Prête', type: 'main' }],
		ON_HOLD: [
			{ to: 'DRAFT', label: 'Brouillon', type: 'secondary' },
			{ to: 'SENT', label: 'Envoyer', type: 'main' },
		],
		READY: [
			{
				to: 'CANCELED',
				label: 'Annuler',
				type: 'secondary',
				alert: 'Êtes-vous sûr de vouloir annuler cette facture ?',
			},
			{ to: 'DRAFT', label: 'Brouillon', type: 'secondary' },
			{ to: 'ON_HOLD', label: 'Bloquer', type: 'secondary' },
			{ to: 'SENT', label: 'Envoyer', type: 'main' },
		],
		SENT: [
			{
				to: 'CANCELED',
				label: 'Annuler',
				type: 'secondary',
				alert: 'Êtes-vous sûr de vouloir annuler cette facture ?',
			},
		],
	},
};
